const severityTypes = {
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  SUCCESS: 'success',
}

export const messageTypes = {
  0: severityTypes.INFO,
  1: severityTypes.SUCCESS,
  2: severityTypes.WARNING,
  3: severityTypes.ERROR,
}

export default severityTypes
